<template>
  <!-- 添加或编辑对话框 -->
  <el-dialog class="xiaobu-form-dialog" :title="baseForm.checkId ? (isEdit ? '编辑盘库单' : '查看盘库单') : '新增盘库单'" v-bind="$attrs" v-on="$listeners">
    <div class="edit-box flex-c-e" v-if="baseForm.checkId && baseForm.checkStatus === '0'">
      <el-button  v-if="mixinHasPermi(['inventory:check:update'])" type="primary" class="edit" @click="toggleEdit">{{
        isEdit ? "取消编辑" : "编辑"
      }}</el-button>
    </div>
    <div class="el-dialog-body-child">
      <item-box class="base-info">
        <template v-slot:title>盘库单基本信息</template>
        <template v-slot:content>
          <el-form class="clearfix" ref="dialogFormRef" :model="dialogForm" :rules="rules"
            :disabled="!!(!isEdit && baseForm.checkId)" label-width="120px">
            <el-form-item v-if="baseForm.checkId" class="half" label="盘库单号" prop="checkNo">
              <el-input disabled v-model.trim="dialogForm.checkNo" clearable placeholder="请输入盘库单号">
              </el-input>
            </el-form-item>
            <el-form-item class="half" label="盘点仓库" prop="checkWareHouseId">
              <el-cascader aria-hidden="false" :options="wareHouseData" clearable :props="defaultProps"
                v-model="dialogForm.checkWareHouseId" @change="handleWareHouseChange" placeholder="请选择盘点仓库" />
            </el-form-item>
            <el-form-item v-if="baseForm.checkId && !isEdit" class="half" label="总盈亏数量" prop="profitLossNumber">
              <el-input disabled v-model.trim="dialogForm.profitLossNumber" clearable ></el-input>
            </el-form-item>
            <el-form-item v-if="baseForm.checkId && !isEdit" class="half" label="总盈亏金额" prop="profitLossPrice">
              <el-input disabled v-model.trim="dialogForm.profitLossPrice" clearable></el-input>
            </el-form-item>
            <el-form-item v-if="baseForm.checkId" class="half" label="盘库状态" prop="checkStatus">
              <el-tag-dict :value="dialogForm.checkStatus" dictType="CHECK_STATUS"></el-tag-dict>
            </el-form-item>
            <el-form-item class="all" label="备注" prop="remark">
              <el-input type="textarea" v-model="dialogForm.remark" :autosize="{ minRows: 5, maxRows: 8 }" clearable
                placeholder="请输入备注" />
            </el-form-item>
          </el-form>
        </template>
      </item-box>

      <item-box class="base-info">
        <template v-slot:title>商品明细</template>
        <template v-slot:content>
          <div class="btn-box" v-if="!baseForm.checkId || baseForm.checkStatus === '0'">
            <el-button type="primary" size="mini" :disabled="!!(!isEdit && baseForm.checkId)" @click="handleAdd">添加商品</el-button>
            <el-button type="danger" size="mini" v-if="!(!isEdit && baseForm.checkId)" :disabled="spuList.length === 0"
              @click="handleClearAll">清空商品</el-button>
          </div>
          <el-table :data="spuList">
            <el-table-column align="left" prop="goodsName" label="商品名称" min-width="128px" show-overflow-tooltip></el-table-column>
            <el-table-column align="left" prop="skuListStr" label="规格" min-width="128px"></el-table-column>
            <el-table-column align="center" prop="manufactureDate" label="生产日期" width="128px"></el-table-column>
            <el-table-column align="center" prop="costPrice" label="成本单价(元)" width="128px"></el-table-column>
            <el-table-column align="center" prop="spuNumber" label="库存数量" width="128px"></el-table-column>
            <el-table-column align="center" prop="checkNumber" label="盘库数量" width="160px">
              <template slot-scope="scope">
                <el-input-number class="number-input" :disabled="!!(!isEdit && baseForm.checkId)"
                  v-model="scope.row.checkNumber" :min="0"></el-input-number>
              </template>
            </el-table-column>
            <el-table-column align="center" prop="checkNumber" label="盈亏数量" width="128px">
              <template slot-scope="scope">
                {{ (Number(scope.row.checkNumber) - Number(scope.row.spuNumber)) | numberFilter }}
              </template>
            </el-table-column>
            <el-table-column align="center" v-if="!baseForm.checkId || isEdit" label="操作" width="128px">
              <template slot-scope="scope">
                <el-button type="danger" size="mini" @click="handleDelete(scope.$index)">删除</el-button>
              </template>
            </el-table-column>
          </el-table>
        </template>
      </item-box>

    </div>
    <div slot="footer" class="dialog-footer">
      <template>
        <el-button @click="$emit('close')">{{
          !baseForm.checkId || isEdit ? "取 消" : "关 闭"
        }}</el-button>
        <el-button type="danger" @click="discardEntry" v-hasPermission="['inventory:check:discard']"
          v-show="baseForm.checkId && !isEdit && baseForm.checkStatus === '0'">作 废</el-button>
        <el-button type="success" @click="printCheck"
          v-show="baseForm.checkId && !isEdit && baseForm.checkStatus !== '2'">打印盘库单</el-button>
        <el-button type="primary" @click="submitForm" v-show="!baseForm.checkId || isEdit">保 存</el-button>
        <el-button type="primary" @click="confirmCheck"
          v-show="baseForm.checkId && !isEdit && baseForm.checkStatus === '0'">确认盘库</el-button>
      </template>
    </div>
    <select-spu ref="selectSpu" :wareHouseId="checkWareHouseId" :wareHouseData="wareHouseData"
      :title="'选择商品' + getWareHouseName(checkWareHouseId)" width="1280px" :modal="false" :visible.sync="showSelectSpu"
      :selectIdArr="selectIdArr" @success="handleSuccess" @close="showSelectSpu = false" :modal-append-to-body="true"
      :append-to-body="true" :close-on-click-modal="false" />
    <check-print v-if="baseForm.checkId && baseForm.checkStatus !== '2'" ref="checkNoRef" :spuList="spuList"
      :checkData="dialogForm" :wareHouseData="wareHouseData"></check-print>
  </el-dialog>
</template>
<script>
import { checkApi } from "@/api"
import SelectSpu from "./select-spu.vue"
import CheckPrint from "./check-print.vue"
import { getPathByTreeValue } from "vue2-element-admin-plugin"

export default {
  name: "CheckDialog",
  components: { SelectSpu, CheckPrint },
  props: {
    // 是否是编辑
    isUpdate: {
      type: Boolean,
      default: false
    },
    //盘库单数据
    baseForm: {
      type: Object,
      default: () => {
        return {}
      }
    },
    // 仓库数据
    wareHouseData: {
      type: Array,
      default: () => {
        return []
      }
    }
  },
  data() {
    return {
      checkWareHouseId: null, // 
      defaultProps: {
        checkStrictly: false,
        value: "wareHouseId",
        children: "children",
        label: "wareHouseName"
      },
      showSelectSpu: false,
      selectIdArr: [],
      spuList: [],
      isEdit: false, // 是否是在编辑
      dialogForm: {
        checkWareHouseId: null
      }, // 弹框表单
      // 表单校验
      rules: {
        checkWareHouseId: [
          {
            required: true,
            message: "请选择盘点仓库",
            trigger: ["blur", "change"]
          }
        ]
      }
    }
  },
  watch: {
    showSelectSpu(val) {
      if (!val) {
        this.$refs.selectSpu.clearSelection()
      }
    },
    isUpdate(val) {
      this.isEdit = val
    },
    // 监听baseForm变化 拷贝baseForm
    baseForm: {
      handler: function(val) {
        this.dialogForm = JSON.parse(JSON.stringify(val))
        this.checkWareHouseId = (Array.isArray(this.dialogForm.checkWareHouseId) ? this.dialogForm.checkWareHouseId[this.dialogForm.checkWareHouseId.length - 1] : this.dialogForm.checkWareHouseId) || null
        this.renderSpuList()
      },
      immediate: true,
      deep: true
    }
  },
  async created() {

  },
  methods: {
    // 清空所有入库商品
    handleClearAll() {
      const _this = this
      this.$modal.confirm("确认清空所有盘库商品吗？", {
        beforeClose: (action, instance, done) => {
          // 关闭前调整遮罩层
          _this.mixinRemoveAndAddMask()
          done()
        }
      }).then(() => {
        _this.spuList = []
      })
    },
    // 获取仓库名字
    getWareHouseName(val) {
      if (!val) { return "" }
      const list = getPathByTreeValue(this.wareHouseData, val, { targetField: "wareHouseId", childrenField: "children" }, true)
      return "(" + list[list.length - 1].labelArr.join("/") + ")"
    },
    printCheck() {
      this.$nextTick(() => {
        this.$refs.checkNoRef && this.$refs.checkNoRef.print()
      })
    },
    // 盘点仓库改变事件
    handleWareHouseChange(val) {
      this.checkWareHouseId = (Array.isArray(this.dialogForm.checkWareHouseId) ? this.dialogForm.checkWareHouseId[this.dialogForm.checkWareHouseId.length - 1] : this.dialogForm.checkWareHouseId) || null
      this.spuList = []
    },
    // 作废
    discardEntry() {
      const _this = this
      _this.$modal
        .confirm('是否确认作废盘库单号为"' + _this.dialogForm.checkNo + '"的数据项？')
        .then(function() {
          return checkApi.discardCheck({ checkId: _this.dialogForm.checkId })
        })
        .then(() => {
          _this.$modal.msgSuccess("盘库单作废成功")
          _this.$emit("close")
          _this.$emit("successs")
        }).finally((err) => {
          // 关闭前调整遮罩层
          this.mixinRemoveAndAddMask()
        })
    },
    // 确认盘库
    confirmCheck() {
      checkApi.confirmCheck({ checkId: this.dialogForm.checkId }).then(() => {
        this.$modal.msgSuccess("盘库单确认成功")
        // 刷新角标
        this.$store.dispatch("user/getUserInfo")
        this.$emit("close")
        this.$emit("successs")
      })
    },
    // 渲染已选择的 商品列表
    renderSpuList() {
      // 如果已入库 列表数据 从入库表中获取
      if (this.baseForm.checkId && this.baseForm.checkStatus === "1") {
        checkApi.getCheckDetail({ checkId: this.baseForm.checkId }).then(data => {
          this.spuList = data.rows || []
        })
        return
      }
      this.spuList = this.baseForm.spuListJson
        ? JSON.parse(this.baseForm.spuListJson) : []

      const spuIdArr = this.spuList.map(item => { return item.wareHouseSpuId })
      // 去重一下
      this.selectIdArr = [... new Set(spuIdArr)]
    },

    // 删除
    handleDelete(index) {
      this.spuList.splice(index, 1)
    },
    // 点击新增
    handleAdd() {
      if (!this.dialogForm?.checkWareHouseId) {
        this.checkWareHouseId = ""
        this.$modal.msgWarning("请先选择盘点仓库")
        return
      }
      const selectIdArr = this.spuList.map(item => { return item.wareHouseSpuId })
      // 去重
      this.selectIdArr = [...new Set(selectIdArr)]
      this.showSelectSpu = true
    },
    // 选择好添加的单品
    handleSuccess(spuList) {
      this.showSelectSpu = false

      const list = []
      for (let i = 0; i < spuList.length; i++) {
        const item = spuList[i]
        // 旧的列表中是否存在
        const oldItem = this.spuList.find(childItem => { return childItem.wareHouseSpuId === item.wareHouseSpuId })
        if (oldItem) {
          list.push(oldItem)
        } else {
          list.push({
            ...item,
            checkNumber: item.spuNumber
          })
        }
      }
      this.spuList = list
    },
    // 编辑或取消编辑
    toggleEdit() {
      if (!this.isEdit) {
        this.isEdit = true
        return
      }
      this.isEdit = false
      this.dialogForm = JSON.parse(JSON.stringify(this.baseForm))
      // 渲染已选择的 商品列表
      this.renderSpuList()
    },
    // 重置表单
    resetForm() {
      this.isEdit = false
      this.$nextTick(() => {
        this.$refs.dialogFormRef.clearValidate()
      })
    },
    /** 提交按钮 */
    submitForm() {
      this.$refs["dialogFormRef"].validate(async valid => {
        if (valid) {
          if (this.spuList.length === 0) {
            this.$modal.msgError("请选择盘库商品")
            return
          }

          const params = JSON.parse(JSON.stringify(this.dialogForm))

          params.checkWareHouseId = this.checkWareHouseId

          params.spuList = this.spuList
          //更新
          if (params.checkId) {
            checkApi.updateItem(params).then((data) => {
              this.$modal.msgSuccess("编辑盘库单成功")
              this.$emit("close")
              this.$emit("successs")
              this.spuList = []
            })
          } else {
            //新增
            checkApi.createItem(params).then((data) => {
              this.$modal.msgSuccess("新增盘库单成功")
              this.$emit("close")
              this.$emit("successs")
              this.spuList = []
            })
          }
        }
      })
    }
  }
}
</script>

<style lang="scss" scoped>
::v-deep .item-box {
  .item-content-box {
    .el-table {
      .el-table__row {
        &.error {
          position: relative;

          &::after {
            content: "";
            pointer-events: none;
            width: calc(100% - 2px);
            height: calc(100% - 2px);
            position: absolute;
            top: 1px;
            left: 1px;
            border: 1px solid red;
            border-radius: 4px;
          }
        }
      }
    }
  }
}

.el-dialog__body {
  .date-input {
    width: 160px;
  }

  .number-input {
    width: 136px;
  }
}
</style>